import React from 'react'

import { useSelector } from 'react-redux'

import type { RecipeUUID } from '@library/menu-service'

import { useRecipe } from 'hooks/menu-recipes/useRecipe'
import { DetailContent as DetailContentExperience } from 'routes/Menu/MenuExperience/Detail/DetailContent'
import { useIsMenuExperienceRecipeDetailEnabled } from 'routes/Menu/components/Detail/hooks/useIsMenuExperienceRecipeDetailEnabled'
import { useRecipeDetailData } from 'routes/Menu/components/Detail/hooks/useRecipeDetailData'
import { getBasketDate, getBasketMenuUuid, getNumPortions } from 'selectors/basket'

import { DetailContent } from '../../Detail/DetailContent'

interface RecipeDetailProps {
  onClose: () => void
  onSelectRecipe?: (recipeId: RecipeUUID) => void
  recipeId: RecipeUUID
}

export const RecipeDetail = ({ onClose, onSelectRecipe, recipeId }: RecipeDetailProps) => {
  const deliveryDate = useSelector(getBasketDate)
  const menuId = useSelector(getBasketMenuUuid)
  const numPortions = useSelector(getNumPortions)
  const menuRecipe = useRecipe(recipeId)
  const isMenuExperienceRecipeDetailEnabled = useIsMenuExperienceRecipeDetailEnabled()

  const { loading, recipe, error, reload } = useRecipeDetailData({
    menuId,
    recipeUuid: recipeId,
    numPortions,
    deliveryDate,
    isMenuExperienceRecipeDetailEnabled,
  })

  if (!menuRecipe?.coreId) {
    return null
  }

  if (isMenuExperienceRecipeDetailEnabled) {
    return (
      <DetailContentExperience
        uuid={menuRecipe.id}
        coreId={menuRecipe.coreId}
        title={menuRecipe.name}
        loading={loading}
        error={error}
        recipe={recipe?.responseType === 'experience' ? recipe : null}
        reload={reload}
        onClose={onClose}
        onSelectRecipe={onSelectRecipe}
      />
    )
  }

  return (
    <DetailContent
      uuid={menuRecipe.id}
      coreId={menuRecipe.coreId}
      title={menuRecipe.name}
      loading={loading}
      error={error}
      recipe={recipe?.responseType === 'v3' ? recipe : null}
      reload={reload}
      onClose={onClose}
    />
  )
}
